


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyD8jI2BGqRmjDq3-HQ0ro1XkbEBJ-3I3cw",
  authDomain: "attendance-learnex.firebaseapp.com",
  projectId: "attendance-learnex",
  storageBucket: "attendance-learnex.firebasestorage.app",
  messagingSenderId: "957422772097",
  appId: "1:957422772097:web:4cd21972947e27a4d7d280"
};



const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export